import React , { useEffect , useState } from "react";
import "./Kenntnisse.css";
import { BodyHeader } from "../../cvComponents/BodyHeader/BodyHeader";
// For Admin
import { allData } from "../../../../Screens/lebenslauf/Lebenslauf";
import { ChangedData } from "../../../../assets/ChangedData/ChangedData";


export const Kenntnisse = (props) =>{

    const data = props.data;
    const title = props.title;
    const allDataindex = props.index;
    /*_*/   const [ RendUi , setRndUi ] = useState("");

    useEffect(()=>{
        rendrui();
    },[]);

    const rendrui = () =>{
        const rend = data.map( (section , index) => 
            <div className="KennAbteilung">
                <li className="KennAbTitle" id={`tkentTiId_${index}`} onClick={toTextEditFunction} onMouseOver={hoverEditOn} onMouseLeave={hoverEditOut} >{section.title}</li>
               { section.rows.map( (row , i) => <p className="KennLineIN" id={`${index}_kentRow_${i}`} onClick={toTextEditFunction} onMouseOver={hoverEditOn} onMouseLeave={hoverEditOut}>{row}</p>)}
            </div>
        );

        setRndUi(rend);


        setTimeout(() => {
            const KennAbteilung = document.getElementsByClassName("KennAbteilung");
            KennAbteilung[KennAbteilung.length - 1].style.border = "none";
        }, 200);
    }








    window.addEventListener("DOMContentLoaded" , ()=>{
        const KennAbteilung = document.querySelectorAll(".KennAbteilung");
        let lengthindex = KennAbteilung.length - 1;
        KennAbteilung[lengthindex].style.border = "none";
        KennAbteilung[lengthindex].style.padding = "0";
    });














    const hoverEditOn = (event) => {
        if (localStorage.getItem("isLogged") == "true") {
            event.target.classList.add("editCursurOnHover");
        }
    }
    const hoverEditOut = (event) => {
        let TargetElement = event.target;
        let inn = TargetElement.classList[0];
        let toRemoveElement = document.querySelector("."+inn+" .EditLogoContainer");
        if (toRemoveElement){
            TargetElement.removeChild(toRemoveElement);
        }
    }

    const toTextEditFunction = (event) => {
        
        if (localStorage.getItem("isLogged") == "true") {

            function onlySpaces(str) {
                return str.trim().length === 0;
            }

            let toTextEdit = event.target;
            let Oldtext = toTextEdit.innerText;
            let Classes = toTextEdit.classList;
            let width = toTextEdit.getBoundingClientRect().width;
            let height = toTextEdit.getBoundingClientRect().height;
            let id = toTextEdit.linke;
    
            toTextEdit.innerHTML = "";
            let textArea = document.createElement("textarea");
            toTextEdit.appendChild(textArea);
            textArea.classList.add("TextEditArea");
    
            for (let i = 0; i < Classes.length; i++) {
                textArea.classList.add(Classes[i]);
            }
    
            textArea.focus();
            textArea.value = Oldtext;
    
            textArea.style.width = width + 20 + "px";
            textArea.style.height = height + 10 + "px";
    

            toTextEdit.addEventListener("focusout" , ()=> {
                
                if ( !onlySpaces(textArea.value)) {
                    let NewValueTextarea = textArea.value
                    toTextEdit.innerHTML = NewValueTextarea;
                    // file name
                    let APIfileName = "CVsections";
                    // atribut name
                    let atributname = event.target.id;
                    // get text after chanched
                    let textafter = event.target.innerHTML;

                    let findIndexOf = atributname.indexOf("_");
                    let mainIndex = atributname.substring(0 , findIndexOf);


                    if (Oldtext != textafter) {
                        let SaveChangContainer = document.getElementById("SaveChangContainer");
                        SaveChangContainer.style.visibility = "visible";

                        if (atributname[0] == "t") {
                            allData.sec[allDataindex].dat[atributname.match(/\d+/g)[0]].title = textafter;
                        }else{
                            let rowIndex = atributname.substring(findIndexOf ,  atributname.length).match(/\d+/g)[0];
                            allData.sec[allDataindex].dat[mainIndex].rows[rowIndex] = textafter;
                        }

                        // allData.sec[index[0]].head.title = textafter;
                        if ( !ChangedData[APIfileName]) {
                            ChangedData[APIfileName] = allData;
                            console.log(ChangedData);
                        }else{
                            ChangedData[APIfileName] = allData;
                            console.log(ChangedData);
                        }
                    }
                }else{
                    // return old Text
                    toTextEdit.innerHTML = Oldtext;
                }
            });
            
            toTextEdit.addEventListener("keydown" , ()=> {
                textArea.style.width = "max-content";
                textArea.style.height = "max-content";
            });
        }
        
    }



































    return(
        <div>
            <BodyHeader title={title} idd={allDataindex} />

            <div className="MainInfoAMC" id="MainInfoAMCK">

                { RendUi }


                {/* 
                <div className="KennAbteilung">
                    <li className="KennAbTitle">Computertechnik</li>

                    <p className="KennLineIN"> 10-Finger-System - Grundkenntnisse </p>
                    <p className="KennLineIN"> Microsoft Office Paket (Word, Excel, Power Point) - Gute Kenntnisse </p>
                    <p className="KennLineIN"> Adobe Programme (Photoshop, Illustrator, XD, InDesign) - Gute Kenntnisse </p>
                    <p className="KennLineIN"> HTML / CSS - Sehr gute Kenntnisse </p>
                    <p className="KennLineIN"> JavaScript, PHP - Gute Kenntnisse </p>
                    <p className="KennLineIN"> Java - Grundkenntnisse </p>
                    <p className="KennLineIN"> MySQL Datenbank - Gute Kenntnisse </p>

                </div>
                
                <div className="KennAbteilung">
                    <li className="KennAbTitle">Sprachkenntnisse</li>
                    <p className="KennLineIN"> Arabisch - Muttersprache </p>
                    <p className="KennLineIN"> Deutsch - B1 </p>
                    <p className="KennLineIN"> Englisch -  A2 </p>
                </div>
                */}

            </div>
        </div>
    );
}